import React, { useEffect, useState } from "react";

const INTRO_VIDEO = "/assets/intro.mp4";

const About = () => {
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (!playing) return;
    const onKey = (e) => e.key === "Escape" && setPlaying(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [playing]);

  return (
    <section id="about" className="section rv">
      <div className="pagewrap">
        <div className="shead">
          <div>
            <div className="snum">[ 01 / ABOUT ]</div>
            <h2 className="h2">
              A builder who cares
              <br />
              about what ships.
            </h2>
          </div>
          <span className="mono hide-mobile" style={{ fontSize: 12, color: "var(--muted)" }}>
            FULL-STACK · AI · AWS
          </span>
        </div>
        <div className="about-grid">
          <div className="posrel" style={{ width: "100%", maxWidth: 480 }}>
            <div
              className="posrel"
              style={{ width: "100%", padding: 12, background: "#fff", border: "1px solid var(--line)", borderRadius: 4, boxSizing: "border-box" }}
            >
              <span className="tick" style={{ top: -1, left: -1, borderWidth: "2px 0 0 2px" }} />
              <span className="tick" style={{ bottom: -1, right: -1, borderWidth: "0 2px 2px 0" }} />
              <button type="button" className="video-thumb" onClick={() => setPlaying(true)} aria-label="Play introduction video">
                <img src="/assets/intro-video-thumb.png" alt="Watch: meet Mohsin Idrees" />
                <span className="video-play" />
              </button>
            </div>
            <div className="mono" style={{ fontSize: 11, color: "var(--muted)", marginTop: 12, letterSpacing: ".08em" }}>
              FIG. 02 — MEET MOHSIN · 90 SEC
            </div>
          </div>
          <div>
            <p style={{ fontSize: 19, lineHeight: 1.65, margin: "0 0 18px", fontWeight: 500 }}>
              Hi, I'm Mohsin. I'm a software engineer focused on solving real problems with AI automation, full-stack development, and scalable AWS cloud
              solutions.
            </p>
            <p className="lead" style={{ margin: "0 0 16px" }}>
              Over the last 5+ years I've shipped products for startups, enterprises, and agencies, from AI chatbots and agentic workflows to serverless
              platforms on AWS. That work taught me to move fast without cutting corners.
            </p>
            <p className="lead" style={{ margin: "0 0 30px" }}>
              Today I work remotely with global clients, turning slow, manual processes into products that run themselves.
            </p>
            <div className="fx gap16 ac wrap">
              <a href="#contact" className="btn btn-primary" style={{ padding: "12px 24px", fontSize: 14 }}>
                Book a call<span className="arr">→</span>
              </a>
              <a href="mailto:contact@mohsin-idrees.com" className="mono fs13">
                contact@mohsin-idrees.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {playing && (
        <div className="video-modal" data-lenis-prevent onClick={() => setPlaying(false)}>
          <div className="video-modal-box" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="video-modal-close" onClick={() => setPlaying(false)} aria-label="Close video">
              ×
            </button>
            <div className="video-modal-frame">
              {/* self-hosted so no third-party player links/overlays appear */}
              <video
                src={INTRO_VIDEO}
                poster="/assets/intro-video-thumb.png"
                controls
                autoPlay
                playsInline
                style={{ width: "100%", height: "100%", display: "block" }}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default About;
